var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSmiley = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9875 0C6.0875 0 0.5 5.6 0.5 12.5C0.5 19.4 6.0875 25 12.9875 25C19.9 25 25.5 19.4 25.5 12.5C25.5 5.6 19.9 0 12.9875 0ZM8.625 7.5C9.6625 7.5 10.5 8.3375 10.5 9.375C10.5 10.4125 9.6625 11.25 8.625 11.25C7.5875 11.25 6.75 10.4125 6.75 9.375C6.75 8.3375 7.5875 7.5 8.625 7.5ZM13 20C10.15 20 7.725 17.925 6.75 15H19.25C18.275 17.925 15.85 20 13 20ZM17.375 11.25C16.3375 11.25 15.5 10.4125 15.5 9.375C15.5 8.3375 16.3375 7.5 17.375 7.5C18.4125 7.5 19.25 8.3375 19.25 9.375C19.25 10.4125 18.4125 11.25 17.375 11.25Z",
    fill: "#0E1F3C"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSmiley);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Smiley.ebbb861b1a2b0138ab44f00aba7b8afc.svg";